/**
 * Global signal for deep-linking to a specific IrisConnection tab.
 * Set before opening settings, read once by IrisConnectionSection on mount.
 * Cleared after reading to prevent stale state on subsequent opens.
 */

// Mirrors the tab union in iris-connection-section.tsx (kept local to avoid a
// circular import). `authentication` is the deep-link target for the per-tile
// Authenticate badge — see configure-badge.tsx.
type IrisConnectionTab = 'monitoring' | 'driver' | 'video' | 'control' | 'authentication';

let pendingDefaultTab: IrisConnectionTab | null = null;

/** Set the default tab for the next IrisConnectionSection mount. */
export const setDefaultConnectionTab = (tab: IrisConnectionTab): void => {
  pendingDefaultTab = tab;
};

/** Read and clear the pending default tab. Returns null if none was set. */
export const consumeDefaultConnectionTab = (): IrisConnectionTab | null => {
  const tab = pendingDefaultTab;
  pendingDefaultTab = null;
  return tab;
};
